import { createFeatureSelector, createSelector } from '@ngrx/store';
import { OrgUiConfig } from 'shared-general-libs/type/org';
import { UserState } from './user.reducer';
import { APP_STORE } from '@ieCore/consts/store.consts';

export const selectUserState = createFeatureSelector<UserState>(APP_STORE.USER);

export const selectUserError = createSelector(
  selectUserState,
  (state: UserState) => state.error,
);

export const selectUser = createSelector(
  selectUserState,
  (state: UserState) => state.user,
);

export const selectUserId = createSelector(
  selectUserState,
  (state: UserState) => state.user?.id,
);

export const selectUserOrganizationId = createSelector(
  selectUserState,
  (state: UserState) => state.user?.orgId,
);

export const selectOrgCountryCode = createSelector(
  selectUserState,
  (state: UserState) => state.user?.orgCountryCode,
);

/**
 * N1 (Wave 5): the tenant's My Tasks column delta, carried on the session
 * payload (`GET /users/me`) exactly like `orgCountryCode` above — NOT read
 * through `OrganizationService.getOrgConfig()`, which requires
 * `Organization.VIEW` and silently swallows the 403 into `{}`. Measured
 * 2026-08-20: 126 of 188 roles that can open My Tasks lack that permission
 * (incl. MRF's Data Owner/Reviewer roles), so the org-read path would
 * silently ship default columns to exactly N1's audience.
 *
 * Cast note (same precedent as `OrgConfigWithDerivedFlags`): `orgUiConfig`
 * reaches the sgl `UserResponseDto` with the Wave-5 sgl addition; until the
 * installed sgl carries it, the getMe payload simply omits the field
 * (=> undefined => platform-default columns). Do NOT strip the cast.
 */
export const selectMyTasksColumnConfig = createSelector(
  selectUser,
  (user) =>
    (
      user as
        | (NonNullable<UserState['user']> & { orgUiConfig?: OrgUiConfig })
        | null
    )?.orgUiConfig?.myTasksColumns,
);
